import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { asyncReceiveDetailThread } from '../states/detailThread/actions';
import ThreadDetail from '../components/ThreadDetail';

const DetailThreadPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { detailThread = null } = useSelector((states) => states);

  React.useEffect(() => {
    dispatch(asyncReceiveDetailThread(id));
  }, [id, dispatch]);

  return detailThread && (
  <ThreadDetail {...detailThread} />
  );
};
export default DetailThreadPage;
